import StatusTag from '@/components/_common/StatusTag';
import {
  SpedDocumentStatusColor,
  SpedDocumentStatusLabel,
} from '@/core/domain/sped/sped-documents/sped-documents.types';
import { useSpedFileConsult } from '@/core/domain/sped/sped-files/sped-files.hooks';
import { useSpedDocumentContext } from '@/pages/FiscalPages/SpedPage/SpedDocumentsPage/SpedDocumentDetailPage';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Button, Modal } from 'antd';

export default function SpedDocumentCheckFiles() {
  const spedDocument = useSpedDocumentContext();

  const hasPermission = hasPermissions([
    Authorities.SPED_DOCUMENT_CONSULT_GENERATE_FILE,
  ]);

  const fileConsult = useSpedFileConsult();

  const consult = async () => {
    if (!spedDocument) return;

    const result = await fileConsult.mutateAsync(spedDocument.id);

    if (result) {
      Modal.info({
        title: 'Consulta de arquivo do documento SPED',
        content: (
          <>
            <StatusTag
              color={SpedDocumentStatusColor[result.status]}
              label={SpedDocumentStatusLabel[result.status]}
            />

            <p>{result.message}</p>
          </>
        ),
      });
    }
  };

  return (
    <Button
      type="primary"
      onClick={consult}
      loading={fileConsult.isLoading}
      disabled={!hasPermission}
    >
      {fileConsult.isLoading ? 'Consultando...' : 'Consultar arquivo'}
    </Button>
  );
}
